module.exports = __webpack_public_path__ + "img/fd81403.png";